import React, { useEffect, useState } from "react";
import { FaPlus, FaEllipsisVertical, FaEye, FaPen } from "react-icons/fa6";
import { MdDelete, MdClose } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { history } from "../../../../store/configure/configureStore";
import ReactPlayer from "react-player";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  TagView,
  ModalView,
} from "../../../controls";
//
import "./ContentDetailsInstagramStyles.scss";

const ContentDetailsView = ({
  fields,
  instagramList,
  tags,
  errors,
  //
  handleCategoryChange,
  handleStatusChange,
  handleTagChange,
  handleAddMultipleTagList,
  handleRemoveTag,
  //
  handelUpdateIds,
  handleInitialTags,
  //
  onClickAddTag,
  onClickContentDetailsSubmit,
  //
  categoryDropDownOptions,
  statusDropDownOptions,
  tagDropDownOptions,
}) => {
  const [tagValue, setTagValue] = useState("");

  useEffect(() => {}, []);

  useEffect(() => {
    handleInitialTags(instagramList[0]?.tag);
  }, []);

  console.log("instagramList", instagramList);
  return (
    <div className="content__management--container">
      <div className="content__management--header-wrapper">
        <div className="title-content">Content Details</div>
      </div>
      <div className="content__management--content-details-wrapper">
        <div className="video-player-block">
          {/* <ReactPlayer url={instagramList[0]?.mediaUrl} /> */}
          <iframe
            width="500"
            height="350"
            src={instagramList[0]?.mediaUrl}
            // src="https://www.instagram.com/reel/CQx9v0yJd1O/embed"
            // src={"//www.youtube.com/embed/VJaLYTGUDS4"}
          ></iframe>

          {/* <iframe
            src="https://scontent.cdninstagram.com/o1/v/t16/f1/m82/D34B899669EF9839518F74B84A7C869C_video_dashinit.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLmNsaXBzLnVua25vd24tQzMuNzIwLmRhc2hfYmFzZWxpbmVfMV92MSJ9&_nc_ht=scontent.cdninstagram.com&_nc_cat=100&vs=316221271542661_1495835661&_nc_vs=HBksFQIYT2lnX3hwdl9yZWVsc19wZXJtYW5lbnRfcHJvZC9EMzRCODk5NjY5RUY5ODM5NTE4Rjc0Qjg0QTdDODY5Q192aWRlb19kYXNoaW5pdC5tcDQVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNZDJ1UnFocjNLMFJna0RBRklYbXZHdGN1a3dicV9FQUFBRhUCAsgBACgAGAAbAYgHdXNlX29pbAExFQAAJuyY5rz074ZAFQIoAkMzLBdARuqfvnbItBgSZGFzaF9iYXNlbGluZV8xX3YxEQB1AAA%3D&ccb=9-4&oh=00_AYBgWOIauFFdY1e-47aN_Hkch-9A3Cxl1TDuHDc6fQWrgw&oe=667B2C92&_nc_sid=1d576d"
            width="640"
            height="360"
            frameborder="0"
            allowfullscreen
          ></iframe> */}
        </div>
        <div className="text-content-block">
          <div className="text-field-block">
            <div className="item-wrapper">
              <span className="label-wrapper">Caption:</span>
              <span className="partition"></span>
              <span className="field-wrapper">{instagramList[0]?.caption}</span>
            </div>
            {/* <div className="item-wrapper">
            <span className="label-wrapper">Playlist:</span>
            <span className="partition"></span>
            <span className="field-wrapper">-</span>
          </div> */}
            <div className="item-wrapper">
              <span className="label-wrapper">Type:</span>
              <span className="partition"></span>
              <span className="field-wrapper">
                {instagramList[0]?.mediaType}
              </span>
            </div>
            <div className="item-wrapper">
              <span className="label-wrapper">Category:</span>
              <span className="partition"></span>
              <span className="field-wrapper">
                {instagramList[0]?.status?.[0]?.status !== "Published" &&
                instagramList[0]?.status?.[0]?.status !== "Reviewed" ? (
                  <Select
                    name="category"
                    isDisabled={
                      instagramList[0]?.status?.[0]?.status === "Published" &&
                      true
                    }
                    placeholder={
                      instagramList[0]?.categoryId?.[0]?.categoryName ||
                      "Please select category"
                    }
                    isrequired={
                      instagramList[0]?.status?.[0]?.status === "Published"
                        ? false
                        : true
                    }
                    options={categoryDropDownOptions}
                    onChange={handleCategoryChange}
                    // placeholder="Please select category"
                    error={errors["category"]}
                  />
                ) : (
                  <span>{instagramList[0]?.categoryId?.[0]?.categoryName}</span>
                )}
              </span>
            </div>
            <div className="tag-list-block">
              <div className="item-wrapper tag-wrapper">
                <span className="label-wrapper">Tags:</span>
                <span className="partition"></span>
                <span className="field-wrapper tag">
                  <TagView
                    name="tag"
                    // value={
                    //   fields?.tag && fields.tag.length > 0
                    //     ? fields.tag[fields.tag.length - 1]
                    //     : null
                    // }
                    value={tagValue}
                    isrequired={true}
                    isMulti={false}
                    isCreatable={false}
                    placeholder={"Please add tag"}
                    options={tagDropDownOptions}
                    onChange={(val) => {
                      handleTagChange(val);
                      // handleAddMultipleTagList(val);
                      if (val.__isNew__ === true) {
                        setTagValue(val);
                      } else {
                        handleAddMultipleTagList(val);
                      }
                    }}
                    error={errors["tag"]}
                  />
                </span>
                <span className="action-btn">
                  <ButtonView
                    // disabled={
                    //   fields?.tag &&
                    //   (!fields.tag.length ||
                    //     !fields.tag[fields.tag.length - 1].__isNew__)
                    // }
                    disabled={tagValue ? false : true}
                    title="Add Tags"
                    styles={"secondary"}
                    onClick={() => {
                      onClickAddTag();
                      if (tagValue.__isNew__ === true) {
                        handleAddMultipleTagList(tagValue);
                      }
                      setTagValue("");
                    }}
                  />
                </span>
              </div>
              {tags.length > 0 && (
                <div className="item-wrapper tag-list-content-wrapper">
                  {tags?.map((item, index) => (
                    <span className="tag-content">
                      <span className="content">
                        {item.label ? item.label : item.tag}
                      </span>
                      <span className="ms-1">
                        {<MdClose onClick={() => handleRemoveTag(index)} />}
                      </span>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="item-wrapper">
              <span className="label-wrapper">Status:</span>
              <span className="partition"></span>
              <span className="field-wrapper">
                <Select
                  name="status"
                  isrequired={true}
                  options={statusDropDownOptions}
                  // placeholder={"Please select status"}
                  placeholder={
                    instagramList[0]?.status?.[0]?.status ||
                    "Please select status"
                  }
                  onChange={handleStatusChange}
                  error={errors["status"]}
                />
              </span>
            </div>
          </div>
          <div className="action-wrapper">
            <span className="action-btn">
              <ButtonView
                title="Cancel"
                onClick={() => history.push("/media/instagram-management")}
                styles={"light"}
                size={"large"}
              />
            </span>
            <span className="action-btn">
              <ButtonView
                title="Submit"
                onClick={() => {
                  const isPublishedOrReviewed =
                    instagramList[0]?.status?.[0]?.status === "Published" ||
                    instagramList[0]?.status?.[0]?.status === "Reviewed";

                  const tagIds =
                    instagramList[0]?.tag
                      ?.filter((item) => item?._id !== undefined)
                      ?.map((item) => item._id) || [];

                  const data = {
                    category: instagramList[0]?.categoryId?.[0]?._id,
                    tag: [tagIds],
                    status: instagramList[0]?.status?.[0]?._id,
                  };
                  handelUpdateIds(tagDropDownOptions, () =>
                    onClickContentDetailsSubmit(
                      instagramList[0]?._id,
                      isPublishedOrReviewed,
                      data,
                      () => history.push("/media/instagram-management")
                    )
                  );
                }}
                styles={"secondary"}
                size={"large"}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentDetailsView;
